import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import PropTypes from "prop-types";
// import styles from "./style/NewSectionButton.module.css";

const NewSectionButton = (props) => {
  const { onSubmit } = props;
  const [showModalSection, setShowModalSection] = useState(false);
  const [titleInput, setTitleInput] = useState("");
  const [alert, setAlert] = useState("");

  const handleSubmit = () => {
    if (!titleInput) {
      setAlert("You need to set title for section");
      return;
    } else {
      setAlert("");
    }
    onSubmit && onSubmit(titleInput);
    setTitleInput("");
    setShowModalSection(false);
  };

  return (
    <div className="">
      <Button onClick={() => setShowModalSection(true)}>New section</Button>
      <Modal show={showModalSection} onHide={() => setShowModalSection(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Label>Section Name*</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter section title"
            value={titleInput}
            onChange={(e) => setTitleInput(e.target.value)}
          />
          {alert && <div className="text-danger">{alert}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModalSection(false)}
          >
            Close
          </Button>
          <Button onClick={handleSubmit}>Save Changes</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

/* required: display name */
NewSectionButton.displayName = "NewSectionButton";

/* required: props types */
NewSectionButton.propTypes = { onSubmit: PropTypes.func };

/* required: default props */
NewSectionButton.defaultProps = { onSubmit: () => {} };

export { NewSectionButton };
